import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { PageRowProps } from "../../types/PageRowProps";

const PageRow = ({ pages, onChangePageRow, activePage }: PageRowProps) => {
  return (
    <Stack direction="row" spacing={0}>
      <Pagination
        count={pages}
        siblingCount={0}
        boundaryCount={1}
        variant="outlined"
        shape="rounded"
        size="large"
        onChange={onChangePageRow}
        page={activePage}
        color="primary"
        sx={{
          button: {
            backgroundColor: "#FFF",
          },
        }}
      />
    </Stack>
  );
};

export default PageRow;
